"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NovozymesTheme = void 0;

var _styles = require("@material-ui/core/styles");

var _NovozymesRg = _interopRequireDefault(require("./fonts/NZ Typography/WEB/Novozymes-Rg.woff"));

var _NovozymesBd = _interopRequireDefault(require("./fonts/NZ Typography/WEB/Novozymes-Bd.woff"));

var _NovozymesTn = _interopRequireDefault(require("./fonts/NZ Typography/WEB/Novozymes-Tn.woff"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var novozymesRegular = {
  fontFamily: 'Novozymes',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: "\n    local('Novozymes'),\n    local('Novozymes-Regular'),\n    url(".concat(_NovozymesRg["default"], ") format('woff2')\n  "),
  unicodeRange: // eslint-disable-next-line max-len
  'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF'
};
var novozymesBold = {
  fontFamily: 'Novozymes',
  fontStyle: 'bold',
  fontDisplay: 'swap',
  fontWeight: 700,
  src: "\n    local('Novozymes'),\n    local('Novozymes-Bold'),\n    url(".concat(_NovozymesBd["default"], ") format('woff2')\n  "),
  unicodeRange: // eslint-disable-next-line max-len
  'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF'
};
var novozymesLight = {
  fontFamily: 'Novozymes',
  fontStyle: 'light',
  fontDisplay: 'swap',
  fontWeight: 300,
  src: "\n    local('Novozymes'),\n    local('Novozymes-Light'),\n    url(".concat(_NovozymesTn["default"], ") format('woff2')\n  "),
  unicodeRange: // eslint-disable-next-line max-len
  'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF'
};
var NovozymesTheme = (0, _styles.createMuiTheme)({
  spacing: 8,
  typography: {
    fontFamily: 'Novozymes, Arial',
    useNextVariants: true,
    h1: {
      fontSize: '3.5rem',
      fontWeight: 700
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500
    },
    h3: {
      fontSize: '1.125rem',
      fontWeight: 700
    },
    subtitle1: {
      fontSize: '1.5rem',
      letterSpacing: '0.15rem'
    },
    body1: {
      fontSize: '1.25rem'
    },
    body2: {
      fontSize: '0.75rem'
    },
    button: {
      fontSize: '1.125rem',
      letterSpacing: '0.15rem'
    }
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [novozymesRegular, novozymesBold, novozymesLight]
      }
    }
  },
  palette: {
    text: {
      primary: 'rgba(0,0,0,0.8)',
      secondary: 'rgba(0,0,0,0.67)' // secondary: 'rgba(255,255,255,0.95)',

    },
    grey: {
      100: '#f6f7f5',
      300: '#d8d8d8',
      500: '#979797',
      800: '#333333'
    },
    background: {
      "default": '#f7f6f5'
    },
    primary: {
      main: '#C5DA00',
      dark: '#0f3e49',
      light: '#ced8ce',
      contrastText: '#f6f6f6'
    },
    secondary: {
      main: '#2D0028',
      light: '#7C1839'
    }
  }
});
exports.NovozymesTheme = NovozymesTheme;